import styled from "@emotion/styled";
import { fontMerriweather, fontRoboto } from "@product/scmp-sdk";

import { pageStyle } from "~/components/article/article-render/article-content/standard-styles";
import BookmarkLogo from "~/components/article/article-render/live-article/bookmark.svg";
import { Tooltip, tooltipClasses } from "~/components/common/tooltip";
import { ContentShareWidget } from "~/components/content/content-share-widget";

import ShareButtonIcon from "./share-button-icon.svg";

export const Container = styled.div`
  position: relative;

  color: #000000;
`;

export const Header = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  block-size: 23px;
  margin-block-end: 12px;

  border-block-start: 2px #ffca05 solid;
`;

export const Time = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;

  block-size: 23px;
  margin-block-start: -23px;
  margin-inline: 80px 16px;

  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 16px;

  background-color: #ffffff;

  outline: 16px #ffffff solid;

  ${props => props.theme.breakpoints.up("tablet")} {
    font-size: 16px;
    line-height: 19px;
  }
`;

export const TheEnd = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;

  block-size: 23px;
  margin-block-start: -25px;
  margin-inline-end: 16px;
  padding-inline: 6px;

  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 16px;

  background-color: #000000;

  outline: 16px #ffffff solid;

  ${props => props.theme.breakpoints.up("tablet")} {
    font-size: 16px;
    line-height: 19px;
  }
`;

export const StyledBookmarkLogo = styled(BookmarkLogo)`
  margin-block-start: -25px;
  margin-inline: auto 20px;
`;

export const Title = styled.div`
  margin-block-end: 12px;

  font-weight: 700;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 23px;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 16px;

    font-size: 24px;
    line-height: 30px;
  }
`;

export const Authors = styled.div`
  margin-block-end: 12px;

  color: #999999;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 16px;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 16px;
  }
`;

export const Content = styled.div`
  margin-block-end: 20px;

  ${props => pageStyle(props)}
`;

export const ActionBox = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledTooltip = styled(Tooltip)`
  & .${tooltipClasses.tooltip} {
    padding: 0;

    border-radius: 5px;

    background-color: #ffffff;

    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.14), 0 2px 2px 0 rgba(0, 0, 0, 0.12),
      0 1px 3px 0 rgba(0, 0, 0, 0.2);
  }
`;

export const ShareButton = styled.span`
  margin-inline-start: 15px;
  padding-inline-start: 15px;

  cursor: pointer;
  border-inline-start: 1px solid #cccccc;
`;

export const StyledShareButtonIcon = styled(ShareButtonIcon)`
  inline-size: 18px;
  block-size: 16px;
`;

export const ShareBar = styled.div`
  display: flex;
  align-items: center;

  padding-block: 12.5px 14.5px;
  padding-inline: 24px;
`;

export const StyledContentShareWidget = styled(ContentShareWidget)`
  display: flex;
`;

export const ShareLabel = styled.span`
  margin-inline-end: 5px;

  color: #001246;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 16px;
`;
